'use strict';

var version = "0.0.0";

var defaults = {
  title: 'DAY 2 - Conference on Artificial intelligence (CDEP)',
  image: "http://demo.webtv-solution.com/web/data/vignettes/mini/img_59facc69eef3e.jpg",
  list_lag: { fr: "fr", en: "en" },
  duree: "00:00:05",
  date: "01-01-2015"
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * redirect to webtv button.
 */

var RedirectButton = function (_Button) {
  inherits(RedirectButton, _Button);

  function RedirectButton(player, options) {
    classCallCheck(this, RedirectButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-redirect-webtv-control');
    _this.addClass('vjs-icon-redirect-webtv');

    _this.controlText(player.localize('Share'));
    return _this;
  }

  RedirectButton.prototype.handleClick = function handleClick() {
    this.player().getChild('RedirectOverlay').open();
  };

  return RedirectButton;
}(Button);

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * Redirect modal.
 */

var RedirectModal = function (_ModalDialog) {
  inherits(RedirectModal, _ModalDialog);

  function RedirectModal(player, options) {
    classCallCheck(this, RedirectModal);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.playerClassName = 'vjs-redirect-webtv_open';
    return _this;
  }

  RedirectModal.prototype.open = function open() {
    this.player().addClass(this.playerClassName);
    _ModalDialog.prototype.open.call(this);
    this.player().trigger('sharing:opened');
  };

  RedirectModal.prototype.close = function close() {
    this.player().removeClass(this.playerClassName);
    _ModalDialog.prototype.close.call(this);
    this.player().trigger('sharing:closed');
  };

  return RedirectModal;
}(ModalDialog);

/**
 * @return {boolean}
 */

var RedirectContent = function () {
  function RedirectContent(player, options) {
    classCallCheck(this, RedirectContent);

    this.player = player;

    this.options = options;

    this.copyBtnTextClass = 'vjs-redirect-webtv__btn-text';
    this.picker = "picker";
    this._createContent();
  }

  RedirectContent.prototype.getContent = function getContent() {
    return this.content;
  };

  RedirectContent.prototype._createContent = function _createContent() {

    var wrapper = document.createElement('div');

    wrapper.innerHTML = '<div class="vjs-redirect-webtv">\n    <div class="vjs-redirect-webtv__middle">\n        <div class="webtv-content">\n                <a href="' + this.options.link + '" target="_blank">\n                   <img src="http://aabdelkafi-web-dev.webtv-solution.com/player/img/icons/webtv.png"><br>\n                </a>\n                <span>Renvoyer vers la Web TV</span>\n        </div>\n    </div>\n</div>\n  ';
    this.content = wrapper.firstChild;
  };

  return RedirectContent;
}();

var Component = videojs.getComponent('Component');

/**
 * Redirect overlay.
 */

var RedirectOverlay = function (_Component) {
  inherits(RedirectOverlay, _Component);

  function RedirectOverlay(player, options) {
    classCallCheck(this, RedirectOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    return _this;
  }

  RedirectOverlay.prototype._createModal = function _createModal() {
    var content = new RedirectContent(this.player, this.options).getContent();

    this.modal = new RedirectModal(this.player, {
      content: content,
      pauseOnOpen: false,
      temporary: true
    });

    this.el = this.modal.contentEl();

    this.player.addChild(this.modal);
  };

  RedirectOverlay.prototype.open = function open() {
    this._createModal();
    this.modal.open();
  };

  return RedirectOverlay;
}(Component);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-redirect-webtv');
  player.getChild('controlBarTop').addChild('RedirectButton', options);
  player.addChild('RedirectOverlay', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function redirect
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var redirectWebtv = function redirectWebtv(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('RedirectButton', RedirectButton);
videojs.registerComponent('RedirectOverlay', RedirectOverlay);

// Register the plugin with video.js.
registerPlugin('redirectWebtv', redirectWebtv);

// Include the version number.
redirectWebtv.VERSION = version;

module.exports = redirectWebtv;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_redirect_webtv/dist/videojs-redirect-webtv.cjs.js
// module id = 560
// module chunks = 1